import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TicketService } from '../../core/services/ticket/ticket.service';
import { finalize } from 'rxjs/internal/operators/finalize';
import { DetailedTicketDTO } from '../../core/models/dto/detailed-ticket.dto';
import { NgClass } from '@angular/common';
import { AutosizeModule } from 'ngx-autosize';
import { TranslateModule } from '@ngx-translate/core';
import { ReplaceEmojisPipe } from '../../../sb-tools/typescript/pipes/replace-emoji/replace-emojis.pipe';

@Component({
    selector: 'app-ticket-title',
    templateUrl: './ticket-title.component.html',
    styleUrls: ['./ticket-title.component.scss'],
    imports: [FormsModule, NgClass, AutosizeModule, ReactiveFormsModule, TranslateModule, ReplaceEmojisPipe],
})
export class TicketTitleComponent {
    @Input() isFormEmailApi: boolean;
    @Input() ticket: DetailedTicketDTO;

    @ViewChild('editorContainer') editorContainerEl: ElementRef;
    @ViewChild('titleEditorTextarea') textareaEl: ElementRef;
    @ViewChild('title') titleEl: ElementRef;

    isEditorShown = false;
    isSubmitted = false;
    isUpdating = false;
    ticketTitle = new FormControl('');

    constructor(private ticketService: TicketService) {
        this.onKeyDown = this.onKeyDown.bind(this);
    }

    hideEditor(): void {
        this.editorContainerEl.nativeElement.removeEventListener('keydown', this.onKeyDown);
        this.isEditorShown = false;
    }

    onKeyUp(): void {
        const textAreaHeight = this.textareaEl.nativeElement.offsetHeight + 'px';
        this.editorContainerEl.nativeElement.style.setProperty('min-height', textAreaHeight);
    }

    showEditor(): void {
        this.ticketTitle.setValue(this.ticket.title);
        this.isEditorShown = true;
        const titleHeight = this.titleEl.nativeElement.offsetHeight + 'px';
        this.editorContainerEl.nativeElement.style.setProperty('min-height', titleHeight);

        this.editorContainerEl.nativeElement.addEventListener('keydown', this.onKeyDown);

        setTimeout(() => {
            this.textareaEl.nativeElement.style.setProperty('height', titleHeight);

            setTimeout(() => {
                this.textareaEl.nativeElement.classList.remove('d-none');
                this.textareaEl.nativeElement.focus();
            });
        });
    }

    updateTitle(event?: FocusEvent): void {
        if (event?.relatedTarget && (event.relatedTarget as HTMLElement).closest('app-ticket-title')) {
            return;
        }

        this.isSubmitted = true;

        if (this.ticketTitle.invalid) {
            return;
        }

        if (this.ticket.title === this.ticketTitle.value) {
            this.hideEditor();
        }

        this.isUpdating = true;
        this.ticketService
            .updateTitle(this.ticket.id, this.ticketTitle.value.trim())
            .pipe(
                finalize(() => {
                    this.isUpdating = false;
                }),
            )
            .subscribe((newTitle) => {
                this.ticket.title = newTitle;
                this.hideEditor();
            });
    }

    private onKeyDown(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            event.preventDefault();
            if (!this.isUpdating) {
                this.updateTitle();
            }
        }
    }
}
